/* Menú de catálogo de lp-header (show_menu; contrato en sections/lp-header.liquid): aria-expanded, foco atrapado, Esc y fondo cierran, resto inerte. */
(() => {
  const btn = document.querySelector('[data-lp-menu-btn]');
  const menu = document.querySelector('[data-lp-menu]');
  const scrim = document.querySelector('[data-lp-menu-scrim]');
  if (!btn || !menu || !scrim) return;
  const open = () => btn.getAttribute('aria-expanded') === 'true';
  const set = (on, back) => {
    btn.setAttribute('aria-expanded', on);
    menu.classList.toggle('is-open', on);
    scrim.classList.toggle('is-open', on);
    document.documentElement.classList.toggle('lp-menu-open', on);
    document.querySelectorAll('#MainContent, .shopify-section-group-footer-group').forEach((el) => (el.inert = on));
    if (on) menu.querySelector('a')?.focus();
    else if (back) btn.focus();
  };
  btn.addEventListener('click', () => set(!open(), true));
  scrim.addEventListener('click', () => set(false, true));
  document.addEventListener('keydown', (e) => {
    if (!open()) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      set(false, true);
    } else if (e.key === 'Tab') {
      const all = [btn, ...menu.querySelectorAll('a[href]')];
      const at = all.indexOf(document.activeElement);
      const to = e.shiftKey ? (at < 1 ? all.length - 1 : -1) : at < 0 || at === all.length - 1 ? 0 : -1;
      if (to >= 0) {
        e.preventDefault();
        all[to].focus();
      }
    }
  });
  // Un enlace cierra el panel (los de ancla no recargan); el del carrito abre el lateral propio si existe
  menu.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a) return;
    const cart = document.getElementById('cart-icon-bubble');
    const lateral = a.hasAttribute('data-lp-menu-cart') && cart && document.getElementById('lp-cart');
    if (lateral) e.preventDefault();
    set(false, false);
    if (lateral) cart.click();
  });
  matchMedia('(min-width: 750px)').addEventListener('change', (e) => e.matches && open() && set(false, false));
})();
